import React from 'react';
import { Link } from 'react-router-dom';
import { Check, ShoppingBag, Images } from 'lucide-react';
import colors from '../theme/colors';
import { hennaServices } from '../data/mock';
import { Button } from '../components/ui/button';

const Henna = () => {
  return (
    <div style={{ backgroundColor: colors.background }} className="min-h-screen">
      {/* Header Section */}
      <section style={{ background: `linear-gradient(135deg, ${colors.white} 0%, ${colors.background} 100%)` }} className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 style={{ color: colors.primary }} className="text-5xl md:text-6xl font-bold mb-6">Henna Art Services</h1>
          <p style={{ color: colors.text.medium }} className="text-xl max-w-3xl mx-auto leading-relaxed">
            From traditional bridal designs to contemporary patterns, we create beautiful henna art for every occasion.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="space-y-24">
          {hennaServices.map((service, index) => (
            <div 
              key={service.id}
              className={`flex flex-col ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-12 items-center`}
            >
              {/* Image */}
              <div className="w-full md:w-1/2">
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img 
                    src={service.image} 
                    alt={service.title}
                    className="w-full h-96 object-cover transition-transform duration-500 hover:scale-105"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2">
                <h2 style={{ color: colors.primary }} className="text-4xl font-bold mb-4">{service.title}</h2>
                <p style={{ color: colors.text.medium }} className="text-lg mb-6 leading-relaxed">
                  {service.description}
                </p>
                <div className="space-y-3 mb-8">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center space-x-3">
                      <div style={{ backgroundColor: colors.highlight }} className="rounded-full p-1">
                        <Check style={{ color: colors.white }} size={16} />
                      </div>
                      <span style={{ color: colors.text.medium }} className="text-base">{feature}</span>
                    </div>
                  ))}
                </div>
                <Link to="/contact">
                  <Button
                    style={{ backgroundColor: colors.highlight, color: colors.white }}
                    className="px-6 py-5 text-base font-semibold rounded-full transition-all duration-300 hover:opacity-90"
                  >
                    Book This Service
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Buy Henna Cone Banner */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <Link to="/buy-henna-cone">
          <div 
            style={{ 
              background: `linear-gradient(135deg, ${colors.highlight} 0%, ${colors.secondary} 100%)`,
              color: colors.white 
            }}
            className="rounded-2xl p-12 text-center transition-all duration-300 hover:shadow-2xl hover:scale-[1.02] cursor-pointer"
          >
            <ShoppingBag size={48} className="mx-auto mb-4" />
            <h3 className="text-3xl md:text-4xl font-bold mb-4">Wanna Buy Organic Henna Cones?</h3>
            <p className="text-lg md:text-xl mb-6 opacity-95">
              Get premium quality, 100% organic henna cones delivered to your doorstep
            </p>
            <div className="inline-flex items-center space-x-2 text-lg font-semibold">
              <span>Shop Now</span>
              <ShoppingBag size={20} />
            </div>
          </div>
        </Link>
      </section>

      {/* Gallery CTA */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div style={{ backgroundColor: colors.white }} className="rounded-2xl p-12 text-center shadow-lg">
          <Images style={{ color: colors.highlight }} size={48} className="mx-auto mb-4" />
          <h3 style={{ color: colors.primary }} className="text-3xl font-bold mb-4">View Our Gallery</h3>
          <p style={{ color: colors.text.medium }} className="text-lg mb-6 max-w-2xl mx-auto">
            Explore our collection of beautiful henna designs and get inspired for your next occasion
          </p>
          <Link to="/gallery">
            <Button
              style={{ backgroundColor: colors.primary, color: colors.white }}
              className="px-6 py-5 text-base font-semibold rounded-full transition-all duration-300 hover:opacity-90"
            >
              View Gallery
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Henna;